import styled from "styled-components";
import { theme } from "../../../theme";

const ConfirmEm = styled.em`
  ${theme.typo.body.m14};
`;

const Li = styled.li`
  list-style: disc;
  color: ${theme.colors.gray3};
  ${theme.typo.body.r12};
`;

export { ConfirmEm, Li };
